import { render, staticRenderFns } from "./config_index.vue?vue&type=template&id=667b79f7&scoped=true"
import script from "./config_index.vue?vue&type=script&lang=js"
export * from "./config_index.vue?vue&type=script&lang=js"
import style0 from "./config_index.vue?vue&type=style&index=0&id=667b79f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667b79f7",
  null
  
)

export default component.exports